import React from 'react';
import PropTypes from 'prop-types';

import { SuiSpinner, SuiSlidePanel } from '@splashthat/sui';

import { PANEL_DISPLAY_RIGHT, PANEL_DISPLAY_LEFT } from 'common/entities/form/styleConfiguration/constants';

const PANEL_POSITIONS = {
    [PANEL_DISPLAY_RIGHT]: 'right',
    [PANEL_DISPLAY_LEFT]: 'left',
};

const Slide = ({ children, panelDisplay, open, loading, onRequestClose }) => (
    <SuiSlidePanel
        open={open}
        position={PANEL_POSITIONS[panelDisplay]}
        onRequestClose={onRequestClose}
        showCloseButton={false}
    >
        {loading ? <SuiSpinner /> : children}
    </SuiSlidePanel>
);

Slide.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    open: PropTypes.bool,
    loading: PropTypes.bool,
    onRequestClose: PropTypes.func.isRequired,
    panelDisplay: PropTypes.oneOf([PANEL_DISPLAY_LEFT, PANEL_DISPLAY_RIGHT]),
};

Slide.defaultProps = {
    open: false,
    loading: false,
    panelDisplay: PANEL_DISPLAY_LEFT,
};

export default Slide;
